import { TemplateData, TemplateParams } from '.';

const calendarEventCanceled = ({
  defaultPlaceholders,
  messages
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.calendarEventEmailDeleteYouWerePreviously}
        ${messages.calendarEventEmailDeleteEventCanceled}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.emailGreeting,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: ${messages.calendarEventEmailDeleteHasBeenCanceled}`
  },
  placeholders: {
    eventTime: {
      label: messages.calendarEventDateAndTime,
      example: '27.3.2024 08:00 - 10:00'
    },
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventCanceled
});

export default calendarEventCanceled;
